import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { withdrawApplicationRoute } from '@features/applicant';
import { applicantApplicationsKey } from '@features/applications';
import { errorMessage } from '@features/profile';
import axiosInstance from '@server/axiosInstance';
import { eventsKey } from '@features/events';

type UseWithdrawApplicationProps = {
  setErrorText: Dispatch<SetStateAction<string>>;
};

export const useWithdrawApplication = ({
  setErrorText,
}: UseWithdrawApplicationProps) => {
  const client = useQueryClient();

  const {
    mutate: withdrawApplication,
    isLoading: isWithdrawApplicationLoading,
  } = useMutation({
    mutationFn: (variables: { application_id: number }) =>
      axiosInstance
        .post(withdrawApplicationRoute, variables, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status !== 200) {
        setErrorText(data.message);
      } else {
        setErrorText('');
        client.invalidateQueries([applicantApplicationsKey]);
        client.invalidateQueries([eventsKey]);
      }
    },
    onError: () => {
      setErrorText(errorMessage);
    },
  });

  return {
    withdrawApplication,
    isWithdrawApplicationLoading,
  };
};
